import React, { Component } from 'react'
import PropTypes from 'prop-types'

class FamilyCard extends Component {
	render() {
		return (
			<div className='theme-card card no-margin' onClick={ this.props.onClick }>
				<div className='card-image valign-wrapper' style={ { backgroundImage: `url('${ this.props.image }')` } }>
					<div className='theme-bg' style={ { backgroundColor: `rgb(${ this.props.color })` } }/>
					<span className='theme-title no-margin'>{ this.props.title }</span>
					<div className='theme-content right-align'>
						{ this.props.children }
					</div>
				</div>
			</div>
		)
	}
}

FamilyCard.propTypes = {
	image: PropTypes.string.isRequired,
	color: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	children: PropTypes.element,
	onClick: PropTypes.func
}

FamilyCard.defaultProps = {
	image: '',
	color: '',
	title: null,
	children: null,
	onClick: () => {
	}
}

export default FamilyCard



// WEBPACK FOOTER //
// ./src/administration/components/themeinformation/FamilyCard.js